import { render } from "./VideoCount.vue?vue&type=template&id=d40d7ca6&ts=true"
import script from "./VideoCount.vue?vue&type=script&lang=ts"
export * from "./VideoCount.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__